/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import OptionIcon from 'assets/icons/options-icon'
import capitalize from 'utils/capitalize'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'

import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper } from '../style'
import {renderSitesStatusIcon} from '../../SitesManagement/sitesTable'
import { SortingArrowWrapper } from 'components/SortingArrow/style'

export const makeSiteDetailsTabRow = (siteDetailsTableData) => {
  return siteDetailsTableData.map((item) => {
    const siteStatus = item.kbaStatus
    return {
      siteCode: item.siteCode,
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || '-'),
      siteName: item.siteName || '-',
      siteNameNational: item.siteNameNational || '-',
      systems: item.systems || '-',
      sensitive_site: item.sensitive_site ? 'Yes' : 'No',
      siteAreaCalculated: item.siteAreaCalculated != null ? item.siteAreaCalculated : '-',
      year: item.year || '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      kbaTriggered: Array.isArray(item.kbaCriterias) ? item.kbaCriterias.join(', ') : (item.kbaCriterias || '-'),
      options: <ReportsFactsheetWrapper>
        <ReportsFactsheetIconWrapper>
          <ExternalLinkIcon />
        </ReportsFactsheetIconWrapper>
        <ReportsFactsheetIconWrapper>
          <OptionIcon />
        </ReportsFactsheetIconWrapper>
      </ReportsFactsheetWrapper>
    }
  })
}

export const makeSiteDetailsTabColumns = (sorting, setSorting, rows) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteId = () => {
    sortFunction('siteCode')
  }

  const sortBySiteNameEng = () => {
    sortFunction('name')
  }

  const sortBySiteNameNational = () => {
    sortFunction('siteNameNational')
  }

  const sortBySiteArea = () => {
    sortFunction('siteAreaCalculated')
  }

  const sortByYear = () => {
    sortFunction('year')
  }

  const sortByKbaStatus = () => {
    sortFunction('SiteStatusId')
  }

  const lastColumnWidth = typeof screen !== 'undefined'
    ? screen.width - 414 - getStickyTableColumnsLength('region', rows) - getStickyTableColumnsLength('country', rows, 150, true) - getStickyTableColumnsLength('siteName', rows, 200) - getStickyTableColumnsLength('siteNameNational', rows, 200) - getStickyTableColumnsLength('systems', rows, 180) - getStickyTableColumnsLength('sensitive_site', rows, 120) - getStickyTableColumnsLength('siteAreaCalculated', rows, 140) - getStickyTableColumnsLength('year', rows, 120) - getStickyTableColumnsLength('kbaClassification', rows, 175) - getStickyTableColumnsLength('kbaTriggered', rows, 190)
    : 100

  return [
    {
      id: 'siteCode',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteId}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      width: 100,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      header: (
        <>
          <FormattedMessage id='region' />
        </>
      ),
      accessorKey: 'region',
      width: getStickyTableColumnsLength('region', rows),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      header: (
        <>
          <FormattedMessage id='countryLabel' />
        </>
      ),
      accessorKey: 'country',
      width: getStickyTableColumnsLength('country', rows, 150, true),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteNameEng' />
          <SortingArrow
            onChange={sortBySiteNameEng}
            checked={sorting.sortBy === 'name' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteNameNational',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteNameNational' />
          <SortingArrow
            onChange={sortBySiteNameNational}
            checked={sorting.sortBy === 'siteNameNational' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteNameNational',
      width: getStickyTableColumnsLength('siteNameNational', rows, 200),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'systems',
      header: (
        <>
          <FormattedMessage id='systems' />
        </>
      ),
      accessorKey: 'systems',
      width: getStickyTableColumnsLength('systems', rows, 180),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'sensitive_site',
      header: (
        <>
          <FormattedMessage id='sensitiveSite' />
        </>
      ),
      accessorKey: 'sensitive_site',
      width: getStickyTableColumnsLength('sensitive_site', rows, 120),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteAreaCalculated',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteArea' />
          <SortingArrow
            onChange={sortBySiteArea}
            checked={sorting.sortBy === 'siteAreaCalculated' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteAreaCalculated',
      width: getStickyTableColumnsLength('siteAreaCalculated', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='lastAssessed' />
          <SortingArrow
            onChange={sortByYear}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      width: getStickyTableColumnsLength('year', rows, 120),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortByKbaStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      width: 180,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      header: (
        <>
          <FormattedMessage id='kbaClassification' />
        </>
      ),
      accessorKey: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaTriggered',
      header: (
        <>
          <FormattedMessage id='kbaTriggered' />
        </>
      ),
      accessorKey: 'kbaTriggered',
      width: getStickyTableColumnsLength('kbaTriggered', rows, 190),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'options',
      header: (
        <>
          <FormattedMessage id='factsheet' />
        </>
      ),
      accessorKey: 'options',
      width: lastColumnWidth > 100 ? lastColumnWidth : 100,
      cell: ({ getValue }) => getValue()
    }
  ]
}
